// player profile popup
window.popupIsActive = false;
window.popup = {
    load: function( ajaxUrl, url, state, preserveHistory ) {
        preserveHistory = !!preserveHistory;

        $c('appMain').loading = true;

        // load the player profile view via ajax...
        axios.get(ajaxUrl).
            then( function(response) {

                // Append to the body
                let el = document.createElement('div');
                el.innerHTML = response.data;
                el.id = 'modalPopup';
                document.querySelector('body').appendChild(el);

                // add to history
                if( ! preserveHistory ) {
                    historyManager.push(url, state);
                }

                $c('appMain').loading = false;

                // mark the popup as being active, this can be picked up in a router and handled + set to false
                popupIsActive = true;
            })
            .catch( ajaxFail );
    },
    close: function(preserveHistory) {
        preserveHistory = !!preserveHistory;

        // remove the element from the DOM
        let el = document.querySelector('#modalPopup');
        if( el ) {
            el.remove();
        }

        if( ! preserveHistory ) {
            historyManager.pop();
        }
    }
};

// player profile popup
window.playerProfile = {
    load: function( player, preserveHistory ) {
        preserveHistory = !!preserveHistory;

        popup.load(
            '/popup/player-profile/' + player.id, //ajaxUrl
            buildPath([ 'player-profile', stringToSlug( player.name ), player.id ]), //url
            player, //state
            preserveHistory
        );
    },
};

//video popup
window.video = (url) => {
    axios.get('/video', { params: { url } }).
        then( (response) => {
            document.querySelector('.__video').innerHTML = response.data;
        });
};

// modal popup
window.modal = (body) => {
    axios.get('/modal', { params: { body }}).
        then( (response) => {
            let div = document.createElement('div');
            div.innerHTML = response.data;
            document.querySelector('body').appendChild(div);
        });
};

// modal confirm popup
window.modalConfirm = (body, button) => {
    return new Promise(resolve => {
        let el = document.createElement('div');

        axios.get('/modal-confirm', { params: { body, button }}).
            then( (response) => {
                el.innerHTML = response.data;
                document.querySelector('body').appendChild(el);

                el.querySelector('.__confirm').addEventListener("click", e => {
                    e.stopPropagation();
                    resolve(true);
                    el.remove();
                });

                el.querySelector('.__cancel').addEventListener("click", e => {
                    e.stopPropagation();
                    resolve(false);
                    el.remove();
                });
            });

    });
};
